import { render, staticRenderFns } from "./viewUpdateDetailUser.vue?vue&type=template&id=bb4a9e46&scoped=true&"
import script from "./viewUpdateDetailUser.vue?vue&type=script&lang=js&"
export * from "./viewUpdateDetailUser.vue?vue&type=script&lang=js&"
import style0 from "./viewUpdateDetailUser.vue?vue&type=style&index=0&id=bb4a9e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4a9e46",
  null
  
)

export default component.exports